export default function ContainerIcon(props) {
    return (
<svg width="19" height="15" viewBox="0 0 19 15" fill="transparent" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M1.625 1.375H17.375M1.625 13.625H17.375M2.5 13.625V1.375M16.5 13.625V1.375M6 10.5625V4.4375M13 10.5625V4.4375M9.5 10.5625V4.4375" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

    );
}

